// Module
var code = `<div style="{{>position}}" class="js-multi-combo-box">
    <div>
        {{#if !.hideAll}}
        <div class="item all">
            <reactFormLabel label="{{allText}}">
                <reactCheckbox 
                    checked="{{.isAllChecked}}" 
                    on-onChange="@this.onAllCheckBoxClicked(\$1)"/>
            </reactFormLabel>
        </div>
        {{/if}}
        <div class="items-container">
            {{#each items as item}}
            <div class="item">
                <reactFormLabel label="{{item.text}}">
                    <reactCheckbox 
                        checked="{{item.checked}}" 
                        on-onChange="@this.onItemCheckBoxClicked(\$1, item)"/>
                </reactFormLabel>
            </div>
            {{/each}}
        </div>
    </div>
</div>`;
// Exports
export default code;